// API error handling
import { Navigate } from "react-router-dom";
import { persistor } from '../redux/store';
import { message } from 'antd'

export const handleApiError = (error) => {
    console.error("API Error: ", error);

    if (error.response) {

        if (error?.response?.data && error?.response?.data?.error) {   // Check for error message in the response data
            return error?.response?.data?.error; // this is the error message from the server
        }
        else if (error?.status === 404) { // this is a custom error message for 404 status code
            return error?.message;
        }
        else if (error?.status === 500) { // this is a custom error message for 404 status code
            return 'Something went wrong!. please contact customer support (Status: 500)';
        }

        return 'Something went wrong!';

    } else if (error?.request) {

        if (error?.code === 'ECONNABORTED') { //request timeout 

            return 'Request timeout or server not responding. Please try again.';
            // this error can occure if the user is offline or the server is down or request timeout 
        }
        return 'Network error. Please check your connection.';  // this error can occure if the user is offline or the server is down.

    } else {
        return error?.message || 'Something went wrong!. please contact customer support.';   // Other errors such as misconfiguration or issues before the request is made
    }
};

